import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import AddButton from "../../../components/AddButton";
import ModalDetail from "../../../components/DetailModal";
import SearchAdvance from "../../../components/SearchAdvance";
import SearchAdvanceForm from "../../../components/SearchAdvanceForm";
import SearchBar from "../../../components/SearchBar";
import PaginatedTable from "../../../components/PaginatedTable";
import {
  getAllPartners,
  deletePartner,
} from "../../../services/userServices/partnerService";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";

const DataMitra = () => {
  const [mitra, setMitra] = useState([]);
  const [rawMitra, setRawMitra] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [nama, setNama] = useState("");
  const [email, setEmail] = useState("");
  const [jenisMitra, setJenisMitra] = useState("");
  const [pengguna, setPengguna] = useState("");
  const [idMitra, setIdMitra] = useState("");
  const [namaIDMitra, setNamaIDMitra] = useState("");
  const [username, setUsername] = useState("");
  const [selectedMitra, setSelectedMitra] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchMitra = async () => {
      try {
        const partners = await getAllPartners();

        const mapped = partners.map((user) => ({
          id: user.id,
          email: user.email || "-",
          nama: user.profiles?.full_name,
          JenisPengguna: user.profiles?.roles?.[0]?.name || "-",
          noHp: user.profiles?.phone,
          alamat: user.profiles?.address,
          idMitra: user.partners?.partner_id,
          namaIDMitra: user.partners?.name_id_partner || "-",
          kodePos: user.partners?.postalcode || "-",
          jenisMitra: user.partners?.partner_type?.name || "-",
          statusKeanggotaan: user.partners?.member_status?.name || "-",
          status: user.partners?.active_status || "-",
          tglJadiMitra: user.partners?.partner_join_date.split("T")[0] || "-",
        }));

        setMitra(mapped);
        setRawMitra(partners);
      } catch (error) {
        console.error("Gagal mengambil data mitra:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMitra();
  }, [location]);

  const columns = [
    { key: "nama", label: "Nama Lengkap" },
    { key: "jenisMitra", label: "Jenis Mitra" },
    { key: "tglJadiMitra", label: "Tanggal Jadi Mitra" },
    { key: "idMitra", label: "ID Mitra" },
    //{ key: "namaIDMitra", label: "Nama ID Mitra" },
    { key: "kodePos", label: "Kode Pos" },
    { key: "email", label: "Email" },
  ];

  const filteredMitra = mitra.filter((m) => {
    const tgl = m.tglJadiMitra;

    if (fromDate && tgl < fromDate) return false;
    if (toDate && tgl > toDate) return false;
    if (nama && !m.nama?.toLowerCase().includes(nama.toLowerCase()))
      return false;
    if (
      jenisMitra &&
      !m.jenisMitra?.toLowerCase().includes(jenisMitra.toLowerCase())
    )
      return false;
    // if (
    //   pengguna &&
    //   !m.JenisPengguna?.toLowerCase().includes(pengguna.toLowerCase())
    // )
    //   return false;
    if (idMitra && !m.idMitra?.toLowerCase().includes(idMitra.toLowerCase()))
      return false;
    if (
      namaIDMitra &&
      !m.namaIDMitra?.toLowerCase().includes(namaIDMitra.toLowerCase())
    )
      return false;
    if (email && !m.email?.toLowerCase().includes(email.toLowerCase()))
      return false;
    if (
      search &&
      ![m.nama, m.jenisMitra, m.idMitra, m.email, m.tglJadiMitra].some(
        (field) =>
          field?.toString().toLowerCase().includes(search.toLowerCase())
      )
    )
      return false;

    return true;
  });

  const handleEdit = (index) => {
    const selected = filteredMitra[index];
    const original = rawMitra.find((m) => m.id === selected.id);

    localStorage.setItem("editMitra", JSON.stringify(original));
    navigate("/edit-mitra");
  };

  const handleDelete = async (index) => {
    const selected = filteredMitra[index];
    if (!selected) return;

    try {
      await deletePartner(selected.id);

      const updated = mitra.filter((item) => item.id !== selected.id);
      setMitra(updated);

      const rawUpdated = rawMitra.filter((m) => m.id !== selected.id);
      setRawMitra(rawUpdated);

      setSelectedMitra(null); // reset jika perlu
    } catch (error) {
      console.error("Gagal menghapus mitra:", error);
      alert("Gagal menghapus data mitra.");
    }
  };

  const handleView = (index) => {
    const selected = filteredMitra[index];
    if (!selected) return;

    const detailData = {
      nama: selected.nama,
      StatusMitra: selected.status,
      JenisPengguna: selected.JenisPengguna,
      StatusKeanggotaan: selected.statusKeanggotaan,
      jenisMitra: selected.jenisMitra,
      tanggalJadiMitra: selected.tglJadiMitra,
      idMitra: selected.idMitra,
      namaIDMitra: selected.namaIDMitra,
      kodePos: selected.kodePos,
      Email: selected.email,
      Alamat: selected.alamat,
    };

    setSelectedMitra(detailData);
    setShowDetailModal(true);
  };

  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    setNama("");
    setJenisMitra("");
    setPengguna("");
    setIdMitra("");
    setNamaIDMitra("");
    setUsername("");
  };

  return (
    <div className="pt-10 pl-64">
      <h2 className="pl-6 mb-6 text-2xl font-semibold text-green-700">
        Data Mitra
      </h2>
      <div className="p-6 mx-4 bg-white shadow rounded-xl">
        <div className="flex items-center justify-between mb-4">
          <AddButton
            onClick={() => navigate("/add-mitra")}
            moduleName="PartnerData"
          />
          <div className="flex items-center gap-2">
            <SearchBar value={search} onChange={setSearch} />
            <SearchAdvance
              showFields={showFields}
              toggleShowFields={() => setShowFields(!showFields)}
            />
          </div>
        </div>

        {showFields && (
          <SearchAdvanceForm
            dateFields={[
              {
                label: "Tanggal Jadi Mitra",
                fromValue: fromDate,
                toValue: toDate,
                onFromChange: setFromDate,
                onToChange: setToDate,
              },
            ]}
            additionalFields={[
              { label: "Nama", value: nama, onChange: setNama },
              {
                label: "Jenis Mitra",
                value: jenisMitra,
                onChange: setJenisMitra,
              },
              // {
              //   label: "Jenis Pengguna",
              //   value: pengguna,
              //   onChange: setPengguna,
              // },
              { label: "ID Mitra", value: idMitra, onChange: setIdMitra },
              // {
              //   label: "Nama ID Mitra",
              //   value: namaIDMitra,
              //   onChange: setNamaIDMitra,
              // },
              { label: "Email", value: email, onChange: setEmail },
            ]}
            onClear={handleClearFilters}
          />
        )}

        {isLoading ? (
          <p className="py-8 text-center text-gray-500">Memuat data mitra...</p>
        ) : (
          <PaginatedTable
            data={filteredMitra}
            columns={columns}
            onEdit={handleEdit}
            onDelete={(index) => {
              setSelectedDeleteIndex(index);
              setIsConfirmOpen(true);
            }}
            onView={handleView}
            moduleName="PartnerData"
          />
        )}

        <ConfirmDialog
          isOpen={isConfirmOpen}
          onClose={() => setIsConfirmOpen(false)}
          onConfirm={() => {
            if (selectedDeleteIndex !== null) {
              handleDelete(selectedDeleteIndex);
              setIsConfirmOpen(false);
              setSelectedDeleteIndex(null);
            }
          }}
          title="Hapus Mitra"
          message="Apakah Anda yakin ingin menghapus data ini?"
        />

        {showDetailModal && (
          <ModalDetail
            data={selectedMitra}
            onClose={() => setShowDetailModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default DataMitra;
